import { useState } from 'react';
import axiosInstance from '../../Services/axiosCommon';
// import { notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../Others/ToastServices';
import useNotification from './useNotification';
import { useSocket } from '../../Context/SocketContext';

const useEditFormData = () => {
  const [isLoading, setIsLoading] = useState(false);
  // const [ api, contextHolder ] = notification.useNotification();
  // const [ data, setData ] = useState(null);
  // const {handleSendNotification} = useNotification();
  const toast = useToast();
  const navigate = useNavigate()

  function Oncancel() {
      navigate(-1);
  }
  const {sendProfileNotification}  =useSocket();


  const editFormData = async ({url="", formData={}, resetForm=()=>{}, navigateUrl="",isclose=false,closeForm=()=>{}}) => {
    setIsLoading(true);

    try {
      const res = await axiosInstance.put(url, formData);
      if (res.data?.status === true) {
        // res.data?.data && setData();
        if (res.data?.notification!==null || res.data?.notification!==undefined || res.data?.notification!==""){
          res.data?.notification && Object.entries(res.data.notification).forEach(([key, value]) => {
          sendProfileNotification({...value,type:1});  
          });
        }
        toast.open({
          type:"success",
          message:"Success",
          description: res.data?.msg || "Created Successfully."
        })
        resetForm();
        if(isclose){
          closeForm()
        }else{
          navigate(`${navigateUrl}`, { state: { data : res.data?.data } }  );
        }
      }
      else if(res.data?.status === false && res.data?.error){
        toast.open({
          type:"error",
          message:"Error",
          description: res.data.error || "Network error. -----"
        })
      } 
      else {
        toast.open({
          type:"warning",
          message:"Warning",
          description: res.data?.msg || "Warning."
        })
      }
    } catch (err) {
    //   setError(err.message);
      console.log(err);
      toast.open({
        type:"error",
        message:"Error",
        description:  "Network error. ------****"
      })
    } finally {
      setIsLoading(false);
    }
  };

  return { editFormData, isLoading,  Oncancel };
};

export default useEditFormData;